import { RiCloseCircleFill } from "react-icons/ri"
import { ImWhatsapp } from 'react-icons/im'
import styled from "styled-components"


export default function ModalFremium(props: any) {
    return (
        <Content>
            <main>
                <header>
                    <span onClick={() => props.closeFremium()}><RiCloseCircleFill /></span>
                </header>
                <h5>🙋‍♂️Pasate a <span>premium</span> y aprovecha los beneficios.</h5>
                <h5><span>Premium</span></h5>
                <ul>
                    <li>✅ Crear categorías <b>ilimitadas</b>.</li>
                    <li>✅ Editar categorías <b>ilimitadas</b>.</li>
                    <li>✅ Código <b>QR</b> para tu menu.</li>
                    <li>✅ Menu disponible para <b>todos</b>.</li>
                    <li>✅ Soporte técnico.</li>
                </ul>
                <h5 className="text-danger mt-2">Gratis</h5>
                <ul>
                    <li>❌ Solo puedes crear 2 categorías.</li>
                    <li>❌ No puedes editar el menu.</li>
                    <li>❌ Nadie puede ver tu menu.</li>
                    <li>❌ Limite de 5 productos por categoría.</li>
                </ul>
                <div className="mt-4 text-center">
                    <h5>Contactanos para ver precios.</h5>
                    {/* <input type="email" placeholder="Introduce tu email" className="form-control w-100" />
                    <button className="btn btn-primary w-100 mt-2">Enviar</button> */}
                    {/* <p className="mt-2">O</p> */}
                    <h6>Contactanos a travez de WhatsaApp</h6>
                    <a href="https://wa.me/8095226730" target={"_blank"} className="btn btn-success">
                        Escribenos <ImWhatsapp />
                    </a>
                </div>
            </main>
        </Content>
    )
}


const Content = styled.div`
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: #00000042;
    z-index:10000;
    display:flex;
    flex-direction:column; 
    justify-content:center; 
    align-items:center;
    main {
        width: 90%;
        min-height: 20vh;
        background:white;
        border-radius: 12px;
        box-shadow: 0px 10px 10px #00000036;
        padding: 2em;
        position: relative;
        ul {
            list-style: none;
            padding: 0!important;
            margin: 0 !important;
        }
    }
    header {
        span {
            position: absolute;
            top: 0;
            right: 5px;
            color: #0000006c !important;
            /* padding: 1em; */
            font-size: 2em;
        }
    }
    span {
        color: #2ecc71;
    }


`